/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {MigrateEscalationTicketRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {MigrateEscalationTicketResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const migrateEscalationTicket = (request: MigrateEscalationTicketRequest, options?: CashRequestOptions) => post<MigrateEscalationTicketRequest, MigrateEscalationTicketResponse>("/2.0/cash/migrate-escalation-ticket", request, {...options, rejectOnError: true })